import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import DatetimePicker from 'vuetify-datetime-picker'

Vue.use(DatetimePicker);
Vue.use(Vuetify)

export default new Vuetify({
});
